export default __webpack_public_path__ + "static/media/5.54f11802.svg";